import { ReactElement } from 'react';

interface IPermissionsHStackProps {
  children: ReactElement[];
}

export function PermissionsHStack({ children }: IPermissionsHStackProps) {
  return <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 4 }}>{children}</div>;
}
